import { ICar } from '../..';

export const CARS_CUPRA: ICar[] = [
  {
    value: 'SeatElBorn',
    caption: 'Cupra Born',
    icon: 'seat-el-born.jpg',
  },
];
